// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__V-KB4","faqsWrapper":"FAQ_faqsWrapper__Spgo5","header":"FAQ_header__XxXBn","collapsed":"FAQ_collapsed__fL5xm","body":"FAQ_body__QpKEf"};